export default {
      id: "about-icon-1-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#about-icon-1",
      toString: function () {
        return this.url;
      }
    }